import React, { Component } from 'react';

class ButtonChild extends Component {
  render() {
    return (
      <button
        className={ this.props.className }
        onClick={ this.props.toggleClassName }
      >
        { this.props.children }
      </button>
    )    
  }
}

export default ButtonChild;